import { createFileRoute } from '@tanstack/react-router'
import { TenantNewPage } from '../../../../features/platform/tenant-new-page'

export const Route = createFileRoute('/platform/_console/tenants/new')({
  component: TenantNewPage,
})
